import React, { useState } from "react";
import Toast from "react-bootstrap/Toast";
import Icon from "./Icon";
import { dequeue, NotificationEvent } from "../notifications/notifications";

interface NotificationPopupProps {
  children: React.ReactNode | string;
  delay: number;
  autohide: boolean;
  variant: string;
  id: string;
  onClose?: () => void;
}

export const NotificationPopup: React.FC<NotificationPopupProps> = ({
  children,
  variant,
  id,
  delay,
  autohide,
  onClose
}) => {
  const [show, setShow] = useState(true);

  const handleClose = () => {
    setShow(false);
    onClose?.();
    dequeue();
    const event = new CustomEvent(NotificationEvent.DELETE, {
      detail: {
        id
      }
    });
    document.dispatchEvent(event);
  };
  return (
    <Toast
      bsPrefix="notification-popup"
      show={show}
      delay={delay}
      onClose={handleClose}
      autohide={autohide}
      className={`notification-popup--${variant}`}
    >
      <Icon
        name="bell-ringing"
        className="notification-popup__notification-icon"
      />
      <div className="notification-popup__content" data-testid="notification">
        {children}
      </div>
      <Icon
        name="close"
        onClick={handleClose}
        className="notification-popup__close-icon"
      />
    </Toast>
  );
};
